export class ContattoDTO {
	email: string;
	pec: string;
	telefono: string;
}